define(function(require) {
	const IpsModel = require('civicsBase/ipsModel');
	return IpsModel.extend({
		urlRoot:'/delegate/civics-api/api/cdr/applicationcontacts/',
		instrumentUrls: {
			building: 'Building/',
			businesslicense: 'BusinessLicense/',
			codeenforcement: 'CodeEnforcement/',
			planning: 'Planning/',
			project: 'Project/',
			tradelicense: 'TradeLicense/',
			use: 'Use/',
			servicerequest: 'ServiceRequests/',
		},
		url: function() {
			if (this.instrumentType){
				if(this.id) {
					return this.urlRoot + this.instrumentUrls[this.instrumentType.toLowerCase()] + this.id;
				} else {
					return this.urlRoot + this.instrumentUrls[this.instrumentType.toLowerCase()];
				}
			}
			return '';
		},
	});
});
